import { Button } from '@/components/button/Button'

type ViewOnlyChatNoticeProps = {
  ownerDisplayName?: string | null
  onStartOwnChat: () => void
  disabled?: boolean
}

function buildOwnerChatMessage(ownerDisplayName?: string | null): string {
  if (!ownerDisplayName) return "You are viewing another collaborator's chat."
  const trimmedName = ownerDisplayName.trim()
  if (!trimmedName) return "You are viewing another collaborator's chat."
  return `You are viewing ${trimmedName}'s chat.`
}

export default function ViewOnlyChatNotice({ ownerDisplayName, onStartOwnChat, disabled = false }: ViewOnlyChatNoticeProps) {
  return (
    <div className="relative w-full max-w-3xl m-auto border-t py-5">
      <div className="w-full self-stretch min-h-[120px] p-3 border border-brand-neutral-200 rounded-[9px] bg-white inline-flex flex-col justify-center items-center gap-1">
        <p className="text-sm text-brand-neutral-600 self-stretch text-center">{buildOwnerChatMessage(ownerDisplayName)}</p>
        <Button color="primary" disabled={disabled} onClick={onStartOwnChat} size="sm" variant="plain">
          Start your own chat
        </Button>
      </div>
    </div>
  )
}
